import styled from 'styled-components'

import { CardStyled } from '@ui/elements/Card'

export const ModalCardStyled = styled(CardStyled)`
  font-size: inherit;
`
